import { t } from "@/i18n-js/instance";
import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../../FirstPaymentPreview/types";

export const HeaderLine = ({ preview, options }: ComponentLineProps) => (
  <DefaultFullPreview.PreviewEntry
    label={t("paywall_checkout.future_payments.header")}
    labelWeight="semibold"
    value={preview?.future_payments?.formatted_total}
    valueWeight="semibold"
    dataTestId="checkout-form-preview-future-payments-total"
    {...options}
  />
);
